<style>
</style>

<script lang="ts">
  import { afterUpdate, tick } from 'svelte'
  import type { NavigatorLocation } from 'svelte-navigator'
  import AboutDigitalGrow from '../components/About_DigitalGrow.svelte'
  import Banner from '../components/Banner.svelte'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Mission from '../components/Mission.svelte'
  import Objectives from '../components/Objectives.svelte'
  import Partners from '../components/Partners.svelte'
  import Strategy from '../components/Strategy.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'
  import Team from '../components/Team.svelte'
  import { Slugs } from '../config/slugs'
  import { fetchAboutData } from '../controllers/AboutController'
  import { lang, aboutPageData } from '../stores/stores'
  import { scrollIntoView } from '../utils/scroll'
  import AnnualReports from '../components/Annual_Reports.svelte'

  export const slug = Slugs.About
  export let location: NavigatorLocation<Record<string, unknown>>
  let isBannerLoaded = false

  fetchAboutData($lang)

  afterUpdate(async () => {
    await tick()
    if (location.hash) scrollIntoView(location.hash)
  })

  function setLoadedBanners() {
    isBannerLoaded = true
  }
</script>

<section>
  <Banner on:bannerLoaded={setLoadedBanners} {slug} />
  {#if isBannerLoaded}
    <Objectives objectives={$aboutPageData.objectives} />
    <Mission mission={$aboutPageData.mission} />
    <Strategy strategy={$aboutPageData.strategy} />
    <Team team={$aboutPageData.team} />
    <AboutDigitalGrow digitalGrow={$aboutPageData.digitalGrow} />
    <AnnualReports annualReport={$aboutPageData.annual_report} />
    <LibraryPlatform />
    <GrowingFamily />
    <SubscribeNewsletter />
    <Partners />
  {/if}
</section>
